<template>
  <div>
    <commBanner :obj="obj" navType="1"></commBanner>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="industry_information warp">
      <!-- <img src="../../assets/images/information_bg.png" alt="" /> -->
      <img :src="imgUrl" alt="" @click="click_top_img(imgUrl_id)" />
      <div class="news_hot">
        <hotNews
          title="换一批"
          limit=6
          :list="hotIndustryinfoList"
          @dataRefresh="getRandomList(6)"
          @sendImgUrl="getImgUrl"
        ></hotNews>
      </div>
    </div>
    <div class="industry_information_content warp">
      <div class="news_item">
        <div class="news_item_nav">
          <ul>
            <li
              :class="current == index ? 'active' : ''"
              v-for="(item, index) in dictList"
              :key="index"
              @click="navChange(index, item)"
              @mouseenter="mouseover(index,item)"
              @mouseleave="mouseLeave(item)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <newsList :list="industryinfoList"></newsList>
        <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.curPage"
          :limit.sync="listQuery.limit"
          @pageChange="pageChange"
        ></Pagination>
      </div>
      <div class="industry_information_recommender">
        <!--推荐资讯-->
        <newsRecommend
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh="getRecommendRandomList(4)"
          urlType="info_detail"
        ></newsRecommend>
         <!--推荐产品-->
        <prodRecommend
          v-if="productList.length > 0"
          @reload="randomProduct"
          :list="productList"
          style="margin-top: 20px"
        ></prodRecommend>
      </div>
    </div>
    <exhibitionInformation
      v-if="activityList.length > 0"
      :list="activityList"
      @onParants="goParants"
      class="warp"
      style="margin-top: 20px"
    ></exhibitionInformation>
  </div>
</template>

<script>
import { getRandomArray } from "../../utils/index";
import {
  getIndustryinfoList,
  getProduct,
  getActivityList,
} from "../../api/information";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import hotNews from "../../common/hotNews";
import newsList from "../../components/newsList";
import newsRecommend from "../../common/newsRecommend";
import prodRecommend from "../../common/prodRecommend";
import exhibitionInformation from "../../common/exhibitionInformation";
import Pagination from "../../components/Pagination";
export default {
  components: {
    commBanner,
    titleHead,
    hotNews,
    newsList,
    newsRecommend,
    prodRecommend,
    exhibitionInformation,
    Pagination,
  },
  provide: {
    urlType: "info_detail",
  },
  data() {
    return {
      obj: {
        title: "行业资讯",
        roleType:'',
        personalType:1,
      },
      newsRecommendObj: {
        title: "推荐资讯",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      current: 0,
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      total: 0,
      allList: [],
      allLists: [],
      industryinfoList: [],
      hotIndustryinfoList: [],
      imgUrl: "",
      imgUrl_id:null,
      currentType: "",
      allProductList: [],
      productList: [],
      activityList: [],
      activeQuery:{
        curPage: 1,
        limit: 10,
      },
      totals:0
    };
  },
  created() {
    this.getHotIndustryinfoList();
    this.getRecommendIndustryinfoList();
    this.getRecommendProduct();
    this.getActivityList();
    if(this.$store.state.user.userInfo != null){
        let type = this.$store.state.user.userInfo.type;
        this.obj.roleType = type;
    }

  },
  computed: {
    dictList() {
      return (
        this.$store.state.industry.list.length > 0 &&
        this.$store.state.industry.list[0].children
      );
    },
  },
  watch: {
    dictList: {
      handler: function(val){
        if(!val[0])return;
        this.currentType = val[0].id;
        this.getIndustryinfoList();
      },
      immediate: true,
    },
  },
  methods: {
     industryList_detection(id){
      var arr = [15,16,17,18]
      if (arr.indexOf(id) != -1){
        return false
      }else{
        return true
      }
    },
    //获取展会列表
    getActivityList() {
      getActivityList({
        ...this.activeQuery,
        recommend: 1,
        type:1
      }).then((res) => {
        if(res.code ==0){
           this.totals = res.page.totalCount;
           this.activityList = this.activityList.concat(res.page.list);
        }
      });
    },
    goParants(item){
       this.activeQuery.curPage = item;
       if(this.tober == this.activityList.length) return;
       this.getActivityList();
    },
    //获取推荐产品
    getRecommendProduct() {
      getProduct({
        curPage: 1,
        limit: 10,
        recommend: 1,
      }).then((res) => {
        if(res.code ==0){
           this.allProductList = res.page.list;
           this.randomProduct();
        }
      });
    },
    //推荐产品
    randomProduct() {
      this.productList = this.randomList(this.allProductList, 3);
    },
    randomList(list, length) {
      return _.compact(getRandomArray(_.cloneDeep(list), length));
    },
    // 分页获取所有行业资讯
    getIndustryinfoList() {
      getIndustryinfoList({
        category: this.currentType,
        curPage: this.listQuery.curPage,
        limit: this.listQuery.limit,
        type: this.currentType,
      })
        .then((res) => {
          if(res.code == 0){
            this.industryinfoList = res.page.list;
            this.total = res.page.totalCount;
          }
        })
        .catch((err) => {});
    },
    //获取热点新闻  前端取随机3个展示
    getHotIndustryinfoList() {
      getIndustryinfoList({
        hot: 1,
      })
        .then((res) => {
          if(res.code ==0){
            this.allList = res.page.list;
            this.getMate(this.allList)
            // this.getRandomList(3);
            this.getRandomList(6);
          }
        })
        .catch((err) => {});
    },
    getRandomList(length) {
      this.hotIndustryinfoList = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
      this.imgUrl = this.hotIndustryinfoList[0].cover;
      this.imgUrl_id=this.hotIndustryinfoList[0].id;
    },
    getImgUrl(item) {
      this.imgUrl = item.cover;
      this.imgUrl_id=item.id;
    },
    click_top_img(imgUrl_id){
      window.open("/info_detail?id="+imgUrl_id);
      //document.location.href="/info_detail?id="+imgUrl_id;
    },
    //获取推荐新闻  前端随机取4个展示
    getRecommendIndustryinfoList() {
      getIndustryinfoList({
        recommend: 1,
      })
        .then((res) => {
          if(res.code ==0){
            this.allLists = res.page.list;
            this.getRecommendRandomList(4);
          }
        })
        .catch((err) => {});
    },
    getRecommendRandomList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allLists), length)
      );
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getIndustryinfoList();
    },
    navChange(index, item) {
      this.current = index;
      this.currentType = item.id;
      this.getIndustryinfoList();
    },
    //移入移出
    mouseover(index,data){
      this.$nextTick(()=>{
        this.current = index;
        this.currentType = data.id;
        this.listQuery.curPage =1;
        this.getIndustryinfoList();
        this.$set(data,'show',true)
      })
    },
    mouseLeave(data){
     this.$set(data,'show',false)
    },
    //seo
    getMate(data){
      var metas = document.getElementsByTagName("meta");
      metas[0].name ="keyword"
      metas[0].content= data[0].seokeywords
      metas[1].name ="description"
      metas[1].content=data[0].seodescription
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
      // document.getElementsByTagName("title")[0].innerText= data[0].title +'_智污邦环保服务平台';
    }
  },

};
</script>

<style scoped lang="less">
.industry_information {
  display: flex;
  justify-content: space-between;
  margin-bottom: 46px;

  img {
    width: 400px;
    height: 312px;
    background-size: cover;
    background-position: center;
  }

  .news_hot {
    width: 60%;
  }
}

.industry_information_content {
   display: flex;
   overflow: hidden;
  .news_item {
    width: 68%;
    margin-right: 30px;
    .news_item_nav {
      line-height: 62px;
      background: url("../../assets/images/bg_8.jpg") no-repeat center/cover;
      ul {
        display: flex;
        padding: 0 30px;
        li {
          cursor: pointer;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          margin-right: 24px;
          &:last-of-type {
            margin-right: 0;
          }
        }
        .active {
          position: relative;
          &::after {
            position: absolute;
            bottom: 10px;
            left: 0;
            display: inline-block;
            content: "";
            width: 100%;
            height: 2px;
            background: #ffffff;
          }
        }
      }
    }
    .el-pagination {
      text-align: center;
      margin-top: 25px;
    }
  }

  .industry_information_recommender {
    width: 29%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/industry_information/industry_information.vue